import { useRouter } from 'next/router';

import { getQueryStringParams } from 'src/utils/helpers';

export type DefaultSearchParameters = {
	q?: string;
	pageIndex?: number;
	topics?: string[];
	access?: string[];
	resources?: string[];
	learning?: string[];
	roles?: string[];
	rcniCategories?: string[];
	content?: string[];
	pageSize?: number;
	sortOption?: number;
	scrollY?: number;
};

export type SearchParameters = {
	[key: string]: string | number | string[];
	q: string;
	pageIndex: number;
	topics: string[];
	access: string[];
	resources: string[];
	learning: string[];
	roles: string[];
	rcniCategories: string[];
	content: string[];
	pageSize: number;
	sortOption: number;
	scrollY: number;
};

const validKeysForArrays = ['topics', 'access', 'resources', 'learning', 'content', 'roles', 'rcniCategories'];

export default function SearchParams(defaultSearchParameters?: DefaultSearchParameters): SearchParameters {
	const router = useRouter();

	const defaultObj: SearchParameters = {
		q: '',
		pageIndex: 1,
		topics: [],
		access: [],
		resources: [],
		learning: [],
		roles: [],
		rcniCategories: [],
		content: [],
		pageSize: 24,
		sortOption: 1,
		scrollY: 0,
		...defaultSearchParameters,
	};

	const entries = Object.entries(getQueryStringParams(router.asPath));

	for (const [key, value] of entries) {
		if (key === 'path') {
			continue;
		}

		if (typeof value === 'string') {
			if (validKeysForArrays.includes(key)) {
				if (value) {
					defaultObj[key] = value.includes(',') ? value.split(',') : [value];
				} else {
					defaultObj[key] = [];
				}
			} else if (parseInt(value) || value === '0') {
				defaultObj[key] = +value;
			} else {
				defaultObj[key] = value;
			}
		}
	}

	return defaultObj;
}
